import { withChartLayout } from 'components/common';
import DiagnosticTest from 'components/features/chart/pre-clinical-manager/diagnostic-test/DiagnosticTest';

const DiagnosticTestsPage = withChartLayout('Diagnostic Tests')(DiagnosticTest);
export default DiagnosticTestsPage;
